export default "__VITE_ASSET__d781ea80__"